import script from "./HomeFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFeatures.vue?vue&type=script&setup=true&lang=js"

import "./HomeFeatures.vue?vue&type=style&index=0&id=3857a9ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3857a9ec"]])

export default __exports__